<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="customer-details-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>

    <!-- CENTER -->
    <div class="center">
        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                        #table
                        class="material"
                        [rows]="rows"
                        [loadingIndicator]="loadingIndicator"
                        [columnMode]="'force'"
                        [headerHeight]="48"
                        [footerHeight]="56"
                        [rowHeight]="'auto'"
                        [scrollbarH]="true"
                        [reorderable]="reorderable"
                        [selectionType]="'checkbox'"
                        [externalPaging]="true"
                        [count]="page.totalElements"
                        [offset]="page.pageNumber"
                        [limit]="page.size"
                        (page)="setPage($event)">


                        <ngx-datatable-column name="{{'Reservation date' | translate}}" prop="invoiceNumber">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                {{'Date'|translate}}:
                                {{row.startDate | date:'dd.MM.yyyy':'UTC' : 'pl'}}
                                {{'Hour'|translate}}:
                                {{row.startDate | date:'H:mm':'UTC' : 'pl'}}
                                -
                                {{row.endDate | date:'H:mm':'UTC' : 'pl'}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'Service' | translate}}" prop="invoiceNumber">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.service">
                                    {{row.service.name}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
